import { Pressable, View } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { StyleSheet } from 'react-native';

import { CenteredRowContainer } from 'components/layout/centered-row-container';
import Picture from 'components/picture';
import { spacing } from 'styles/constants';

import { CTAButtons } from '../components/cta-button';
import { ISimpleHomePageProps } from '../types';
import { sendHeroClickEvent } from '../utils';

import { ButtonsContainer, DisclaimerText, HeaderStyled } from './styled';

export const SimpleHomePageDesktop = ({
  numberOfItemsInCart,
  serviceMode,
  item,
}: ISimpleHomePageProps) => {
  const { header, desktopImage, altImageText, _id, imageLink, imageDisclaimerText, daypart } = item;
  const headerText = header?.locale ?? '';
  const imageAlt = altImageText?.locale ?? '';
  const image = desktopImage?.locale;
  const { navigate } = useRouter();

  const handleOnPress = () => {
    if (imageLink) {
      sendHeroClickEvent({ imageLink, daypart });

      navigate(imageLink);
    }
  };

  return (
    <CenteredRowContainer
      testID="simple-home-page"
      contentFlexDirection="row"
      standardPadding
      style={styles.content}
    >
      <View style={styles.left}>
        <HeaderStyled accessibilityLabel={headerText}>{headerText}</HeaderStyled>
        <ButtonsContainer>
          <CTAButtons
            numberOfItemsInCart={numberOfItemsInCart}
            serviceMode={serviceMode}
            itemId={_id}
          />
        </ButtonsContainer>
      </View>
      <View style={styles.right}>
        {image && (
          <Pressable
            onPress={handleOnPress}
            style={{
              flex: 1,
              cursor: imageLink ? 'pointer' : 'auto',
            }}
          >
            {/* Without an explicit width, Picture pins its boundary to the first
                measured pixel width and can no longer shrink when the window is
                resized, overflowing the hero container. */}
            <Picture image={image} alt={imageAlt} width="100%" />
          </Pressable>
        )}
        {imageDisclaimerText?.locale && (
          <DisclaimerText>{imageDisclaimerText?.locale}</DisclaimerText>
        )}
      </View>
    </CenteredRowContainer>
  );
};

const styles = StyleSheet.create({
  content: {
    paddingTop: spacing.$6,
  },
  left: {
    flex: 1,
    justifyContent: 'center',
  },
  right: {
    flex: 2,
    marginLeft: spacing.$2,
  },
});
